import React from "react";

const HeroImage = ({ title, subtitle, imageSrc }) => {
  const subtitleLines = subtitle.split("\n"); // Split subtitle by new lines
  const getTitleWidth = (title) => {
    if (title === "About us") {
      return "w-[75px]";
    }
    return "w-[71px]"; // default width for other titles like "Services"
  };
  return (
    <section className="w-full flex flex-col items-center justify-center min-h-screen lg:px-[106px] md:px-[64px] px-4">
      <div className="w-[362px] md:w-[561px] lg:w-[913px]  mt-[120px] flex flex-col items-center justify-center  ">
        {/* Heading */}
        
        <h2 className="lora-headline w-[75px] h-[20px] text-[18px] leading-[20px] tracking-[0px] flex items-center justify-center whitespace-nowrap md:w-[88px] md:h-[32px] lg:w-[913px] lg:h-[49px]">
          {title}
          <div className="ml-2">
            {/* Mobile view (default) */}
            <svg 
              className="block md:hidden mt-4" 
              width="32" 
              height="1" 
              viewBox="0 0 32 1" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
              
            >
              <line y1="0.5" x2="32" y2="0.5" stroke="black" strokeWidth="0.5" />
            </svg>

            {/* Tablet view */}
            <svg 
              className="hidden md:block lg:hidden mt-10" 
              width="64" 
              height="1" 
              viewBox="0 0 64 1" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <line y1="0.5" x2="64" y2="0.5" stroke="black" strokeWidth="0.5" />
            </svg>

            {/* Desktop view */}
            <svg 
              className="hidden lg:block mt-10" 
              width="64" 
              height="1" 
              viewBox="0 0 64 1" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <line y1="0.5" x2="64" y2="0.5" stroke="black" strokeWidth="0.5" />
            </svg>
          </div>
        </h2>

        {/* Subtitle with line breaks */}
        <h3 className="text-center font-lora font-medium w-[267px] h-[136px] text-[28px] leading-[34px] tracking-[0%] mt-2
          md:w-[561px] md:h-[76px] md:text-[32px] md:leading-[38px] md:mt-0
          lg:w-[913px] lg:h-[120px] lg:text-[52px] lg:leading-[60px] lg:mt-[24px]">
          {subtitleLines.map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </h3>
      </div>

      {/* Image Section */}
      <div className="w-full  flex items-center justify-center lg:mt-[80px] mt-[80px] md:mt-[118px]">
        <img
          src={imageSrc}
          alt="Description"
          className="lg:w-[1300px] lg:h-[497px] md:w-[707px] md:h-[738px] w-[362px] h-[420px] object-cover rounded-[12px]"
        />
      </div>
    </section>
  );
};

export default HeroImage;
